'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var styleHelper = require('../../helper/styleHelper');
var graphicsHelper = require('../../helper/graphicsHelper');

/*
 @Author : mengxiaojiang
 @CreateDate : 2016-3-31
 @Descript : 分组框组件
 */
var GroupBox = React.createClass({
  render: function () {
    var borderColor = styleHelper.getBorderColor(this.props) || '#ddd';
    var borderCss = '1px solid ' + borderColor;
    var backColor = styleHelper.getBackgroundColor(this.props);
    var style = {
      pointerEvent: 'none',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      position: 'absolute',
      width: styleHelper.getWidth(this.props),
      height: styleHelper.getHeight(this.props),
    };
    var backStyle = {
      boxSizing: 'border-box',
      border: borderCss,
      background: backColor,
      position: 'absolute',
      top: '1.4ex',
      bottom: 0,
      left: 0,
      right: 0
    };

    var textBoxStyle = {
      left:0,
      top:0,
      marginLeft: 20,
      textDecoration:'inherit',
      position:'absolute',
    };

    var lineCoverStyle = {
      position: 'absolute',
      width: '100%',
      height: '1.4ex',
      borderBottom:'1px solid ' + backColor,
      marginBottom: -1,
    };

    var tx = styleHelper.getText(this.props);
    if (!tx.trim()) {
      tx = '\u00a0';
    }
    styleHelper.StyleUtil(this.props, style).text();
    return (
      <div style={style}>
        <div style={backStyle}></div>
        <div style={textBoxStyle}>
          <div style={lineCoverStyle} />
          <label style={{position: 'absolute'}}>{tx}</label>
          <label style={{color: 'transparent'}}>{tx}</label>
        </div>
      </div>
    );
  },

});


module.exports = GroupBox;



// WEBPACK FOOTER //
// ./src/views/Components/GroupBox.jsx